<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row>
        <v-col>
          <v-text-field
            class="ml-6 mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <dot-menu
          @exportExcel="exportExcel"
          :position="'page-top-right'"
          :excelButton="{
            excelData,
            filename: `acqui-utm-content-${this.dateRange}.xlsx`,
          }"
        ></dot-menu>
        <v-col>
          <v-data-table
            class="ml-6 mr-6"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template v-slot:item.date="{ item }">
              <div class="truncateCell" :title="item.date">
                {{ formatDate(item.date) }}
              </div>
            </template>
            <template v-slot:[`item.utm_content`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="truncate-cell" v-bind="attrs" v-on="on">
                    {{ item.utm_content }}
                  </div>
                </template>
                <span>{{ item.utm_content }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.revenue="{ item }">
              <span>{{ formatRevenue(item.revenue) }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped>
.truncate-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>

<script>
import useAxios from "@/hooks/useAxios";
import debounce from "lodash/debounce";
import DotMenu from "@/components/common/menus/DotMenu";
import axios from "@/plugins/axios";

export default {
  name: "utmContentReportTable",
  components: { DotMenu },

  data() {
    return {
      excelData: new Blob([""], { type: "text/plain" }),
      search: "",
      items: [],
      headers: [
        { text: "Date", value: "date" },
        { text: "Site", value: "site_name" },
        { text: "Domain", value: "domain" },
        { text: "UTM Content", value: "utm_content" },
        { text: "Revenue", value: "revenue" },
        { text: "Devise", value: "unit_code" },
      ],
    };
  },

  setup() {
    const { axiosGet, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
    };
  },

  methods: {
    debouncedUpdateData: debounce(async function () {
      await this.getData();
    }, 500),

    async getData() {
      const params = {
        date_start: this.dateRange[0],
        date_end: this.dateRange[1],
      };
      const response = await this.axiosGet(
        "/acquisition/utm-content/report/by_range_date",
        params
      );
      this.items = response.data;
      this.$store.dispatch("common/updateApplyFilters", false);
    },
    formatDate(date) {
      return date.split("T")[0];
    },
    formatRevenue(revenue) {
      return Number(revenue).toFixed(2);
    },
    async exportExcel() {
      const params = {
        date_start: this.dateRange[0],
        date_end: this.dateRange[1],
      };

      const response = await axios.get("acquisition/utm-content/report/excel", {
        params,
        responseType: "blob",
      });

      this.excelData = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  async created() {},
  computed: {
    filtersApplied() {
      return this.$store.getters["common/getApplyFilters"];
    },
    dateRange() {
      return this.$store.getters["acquisition/getDates"];
    },
  },
  watch: {
    filtersApplied() {
      this.debouncedUpdateData();
    },
  },
};
</script>
